
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getUpdateTagDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    technicalName: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    isPublic: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
})
;
}
      